import React, {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {makeStyles} from '@material-ui/core'
import HealthCenterReportStyle from 'pages/HealthCenter/ReportV1/Style'

const useStyles = makeStyles(HealthCenterReportStyle)

type PropsType = {
  title?: string
  children: ReactNode
}

const Analysis = ({title, children}: PropsType) => {
  const {t} = useTranslation()
  const classes = useStyles()
  return (
    <div className={classes.styleAnalysis}>
      <div className={classes.greenLabel}>
        <span>{title ?? t('IAnalysisHealth')}</span>
      </div>
      <div className={classes.contentAnalysis}>{children}</div>
    </div>
  )
}

export default Analysis
